const formatPrice = (price) => {
  const options = {
    style: "currency",
    currency: "EUR",
  };
  return parseFloat(price).toLocaleString("nl-NL", options);
};

export default formatPrice;



// WEBPACK FOOTER //
// ./src/utils/format-price.js